export default (function (_a) {
    var disabled = _a.disabled;
    return "\n  pointer-events: ".concat(disabled ? "none" : "auto", ";\n  cursor: ").concat(disabled ? "default" : "pointer", ";\n");
});
